import { __values } from "tslib";
import { QueryExpType, } from '@tencent/memoire-core';
// QueryExpEliminator eliminates invalid expression
var QueryExpEliminator = /** @class */ (function () {
    function QueryExpEliminator() {
    }
    QueryExpEliminator.prototype.eliminate = function (conditions) {
        var result = conditions;
        result.exp = this.eliminateExp(conditions.exp);
        return result;
    };
    QueryExpEliminator.prototype.eliminateExp = function (exp) {
        if (exp.type === QueryExpType.AND) {
            return this.eliminateAndExp(exp);
        }
        if (exp.type === QueryExpType.OR) {
            return this.eliminateOrExp(exp);
        }
        if (exp.type === QueryExpType.FILTER) {
            return this.eliminateFilterExp(exp);
        }
        return exp;
    };
    QueryExpEliminator.prototype.eliminateAndExp = function (andExp) {
        var e_1, _a;
        var result = { type: QueryExpType.AND, exps: [] };
        try {
            for (var _b = __values(andExp.exps), _c = _b.next(); !_c.done; _c = _b.next()) {
                var exp = _c.value;
                var current = this.eliminateExp(exp);
                if (current.type === QueryExpType.NONE) {
                    return { type: QueryExpType.NONE };
                }
                if (current.type === QueryExpType.ALL) {
                    continue;
                }
                result.exps.push(current);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (!result.exps.length) {
            return { type: QueryExpType.ALL };
        }
        if (result.exps.length === 1) {
            return result.exps[0];
        }
        return result;
    };
    QueryExpEliminator.prototype.eliminateOrExp = function (orExp) {
        var e_2, _a;
        var result = { type: QueryExpType.OR, exps: [] };
        try {
            for (var _b = __values(orExp.exps), _c = _b.next(); !_c.done; _c = _b.next()) {
                var exp = _c.value;
                var current = this.eliminateExp(exp);
                if (current.type === QueryExpType.ALL) {
                    return { type: QueryExpType.ALL };
                }
                if (current.type === QueryExpType.NONE) {
                    continue;
                }
                result.exps.push(current);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        if (!result.exps.length) {
            return { type: QueryExpType.NONE };
        }
        if (result.exps.length === 1) {
            return orExp.exps[0];
        }
        return result;
    };
    QueryExpEliminator.prototype.eliminateFilterExp = function (exp) {
        if (exp.hints.intervalGroup.isEmpty()) {
            return { type: QueryExpType.NONE };
        }
        if (exp.hints.intervalGroup.isFull()) {
            return { type: QueryExpType.ALL };
        }
        return exp;
    };
    return QueryExpEliminator;
}());
export default QueryExpEliminator;
//# sourceMappingURL=query-exp-eliminator.js.map